import React from 'react';

import { Heading, Portfolio } from '../../../components';



const PortfolioSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Our Portfolio'} subTitle={'explore our capabilities'} />

      {/* Portfolio Section */}
      <Portfolio />

    </section>

  );
}

export default PortfolioSection;